import { twMerge } from 'tailwind-merge';
import { Icon, Loader, Tooltip } from '@treezor/design-system';

import { useTranslation } from 'react-i18next';

import { useFavorites } from '@/hooks/useFavorites';

type TWalletStarredProps = {
  isStarred?: boolean;
  onClick?: () => void;
  isLoading?: boolean;
  shouldPreventDefault?: boolean;
};

export function WalletStarred({ isStarred, onClick, isLoading, shouldPreventDefault }: TWalletStarredProps) {
  const { t } = useTranslation();

  const { isLimitReached, maxFavorites } = useFavorites();

  const isDisabled = isLimitReached && !isStarred;

  const getTooltipMessage = () => {
    if (isDisabled) {
      return t('pages.dashboard.favorites.favoriteLimitReached', { max: maxFavorites });
    }
    if (isStarred) {
      return t('pages.dashboard.favorites.removeFavorite');
    }
    return t('pages.dashboard.favorites.starred');
  };

  return (
    <Tooltip messageContent={getTooltipMessage()} contentClassName="text-center">
      <button
        onClick={(e) => {
          if (shouldPreventDefault) {
            e.preventDefault();
            e.stopPropagation();
          }
          onClick();
        }}
        disabled={isDisabled}
        className={twMerge(
          'relative inline-flex justify-center items-center rounded-full p-2 cursor-pointer bg-transparent hover:text-icon-interactive hover:bg-icon-backgroundHover text-icon-secondary pointer-events-auto',
          isDisabled && 'pointer-events-none text-icon-disabled bg-transparent ',
          isStarred && 'text-icon-interactive',
        )}
      >
        {isLoading ? <Loader size="m" color="inherit" /> : <Icon name="star" isFill={isStarred} size="m" />}
      </button>
    </Tooltip>
  );
}
export default WalletStarred;
